/* eslint-disable no-useless-escape */

import React, { Component, Fragment } from "react";
import "./login.scss";
import Snackbar from '@mui/material/Snackbar';
import {
  userLogin,
  acceptInvite,
  forgotPassword,
  resetPasswords,
  autoLogin,
} from "../../ActionCreators/loginAction";
import { clearErrors } from "../../ActionCreators/errorAction";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { BallBeat } from "../../Loader/loader";
import axios from "axios";
import loginImage1 from "../../assets/elite-login1.jpg";
import loginImage2 from "../../assets/elite-login2.png";
import loginImage3 from "../../assets/elite-login3.jpg";
import loginImage4 from "../../assets/saifee-login4.png";
import i18n from "../../i18n";
import Nofound from "./nofound";
import { Helmet } from "react-helmet";
import Lottie from "react-lottie";
import Loading from "../../assets/hour-glass.json";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import GLogin from "./gLogin";

class Login extends Component {
  state = {
    defaultShow: true,
    email: "",
    password: "",
    quoteSelected: [],
    resetPasswordComplete: false,
    newPassword: "",
    otp: "",
    resetComplete: false,
    otpEnable: false,
    isResetPassword: false,
    emailOtpScreen: true,
    isOtpEmailLoading: false,
    isOtpResetLoading: false,
    lang: "en",
    nofound: false,
    showLoading: false,
    credential: null,
    userData: []
  };

  componentDidUpdate = () => {
    if (this.state.credential) {
      axios
        .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${this.state.credential?.credential}`, {
          headers: {
            Authorization: `Bearer ${this.state.credential?.credential}`,
            Accept: 'application/json'
          }
        })
        .then((res) => {
          this.setState({
            userData: res.data
          }, () => {
            console.log(this.state.userData)
          })
        })
        .catch((err) => console.log(err));
    }
  }



  componentDidMount = () => {
    axios.get(process.env.REACT_APP_API_KEY + "company/logo")
      .then((response) => {
        if (response.data.success) {
          this.setState({
            logo: response.data.logo,
            company: response.data.company_name,
            whitelabled: response.data.whitelabled,
            apple_store: response.data.apple_store,
            play_store: response.data.play_store,
          }, () => {
            localStorage.setItem("logo", response.data.logo);
            localStorage.setItem("company", response.data.company_name);
            localStorage.setItem('whitelabelled', JSON.stringify(response.data.whitelabled));
            localStorage.setItem('theme', JSON.stringify(response.data.colors))
          }
          );
        } else {
          this.setState({
            nofound: true,
          });
        }
      }).catch((error) => {
        if (error.response === undefined) {
          this.setState({
            successEnable: true,
            successMessageText: "Something went wrong",
          });
        } else if (error.response.status === 404) {
          this.setState({
            nofound: true,
          });
        } else if (error.response.status === 400
          || error.response.status === 500) {
          this.setState({
            successEnable: true,
            successMessageText: error.response.data.message || "Something went wrong",
          });
        } else {
          this.setState({
            successEnable: true,
            successMessageText: "Something went wrong",
          });
        }
      });
    if (window.location.href.includes("otp")) {
      this.setState({
        defaultShow: false,
        otp: window.location.search.split("=")[1],
      });
    }

    if (window.location.href.includes("auto")) {
      this.checkUserAuth();
    }
    let url = new URL(window.location.href);
    let searchParams = new URLSearchParams(url.search);
    if (searchParams !== null && searchParams.get("success") === "true") {
      this.checkUserAuthForApp();
    }

    if (localStorage.getItem("profileComplete") === "false") {
      this.props.history.push("/add-skills");
    } else {
      if (localStorage.getItem("role") !== null &&
        (localStorage.getItem("role")?.includes("user") ||
          localStorage.getItem("role")?.includes("admin"))
      ) {
        if (localStorage.getItem("loginToken") !== null) {
          (window.location.pathname === "/" ||
            window.location.pathname === "/login") &&
            ((JSON.parse(localStorage.getItem('score')) === null || localStorage.getItem('score') < 20) ? (
              this.props.history.push('/getting-started')) :
              this.props.history.push("/learn"));
        } else {
          (window.location.pathname === "/" ||
            window.location.pathname === "/login") &&
            this.props.history.push("/login");
        }
      }
    }

    // https://learning.saifeehospital.com/
    const imagesList =
      window.location.origin === 'https://learning.saifeehospital.com' ?
        [{ image: loginImage4 }]
        : [
          { image: loginImage1 },
          { image: loginImage2 },
          { image: loginImage3 },
        ];
    let imgSelected = imagesList[Math.floor(Math.random() * imagesList.length)];
    this.setState({
      imgSelected: imgSelected,
    });
  };

  async checkUserAuth() {
    if (window.location.href.includes("auto")) {
      this.setState({
        isLoading: true,
        showLoading: true,
      });
      const code = window.location.href.split("?")[1].split("=")[1];
      await this.props.autoLogin(code);
      setTimeout(() => {
        if (this.props.successMessage === true) {
          this.setState({
            isLoading: false,
            showLoading: false
          });
        }
      }, 1000);
    }
  }

  async checkUserAuthForApp() {
    let url = new URL(window.location.href);
    let searchParams = new URLSearchParams(url.search);
    if (searchParams !== null && searchParams.get("success") === "true") {
      this.setState({
        isLoading: true,
      });
      const code = url.href.split("=")[2].split("&")[0];
      const lang = url.href.split("=")[3];
      i18n.changeLanguage(lang);
      if (lang === "hi") {
        localStorage.setItem("lang", "hi");
      } else if (lang === "en") {
        localStorage.setItem("lang", "en");
      }
      await this.props.autoLogin(code);
      setTimeout(() => {
        if (this.props.successMessage === true) {
          this.setState({
            isLoading: false,
          });
        }
      }, 1000);
    } else if (
      searchParams !== null &&
      searchParams.get("success") === "false"
    ) {
      const code = window.location.href.split("=")[2];
      const filterMessage =
        this.state.errorCodes !== undefined &&
        this.state.errorCodes.filter((el) => el.code === code)[0];
      this.setState({
        isLoading: false,
        successEnable: true,
        successMessageText: filterMessage.message,
      });
    }
  }

  onEmailChange = (e) => {
    this.setState({
      email: e.target.value,
      emailvalidError: false,
      emailError: ''
    });
  };

  onChangePassword = (e) => {
    this.setState({
      password: e.target.value,
      passwordValidError: false,
      passworderror: ''
    });
  };

  loginUser = async () => {
    this.setState({
      isLoading: true,
      responseStatus2: false,
    });
    let emailvalue = this.state.email;
    // eslint-disable-next-line no-useless-escape
    let emailrex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!emailvalue) {
      this.setState({
        emailError: `Email can't be blank`,
        emailvalidError: true,
        isLoading: false,
      });
      return false;
    } else if (!emailrex.test(String(emailvalue))) {
      this.setState({
        emailError: "Email is not valid",
        emailvalidError: true,
        isLoading: false,
      });
      return false;
    } else if (this.state.password === "") {
      this.setState({
        passwordValidError: true,
        passworderror: `Password can't be blank`,
        isLoading: false,
      });
    } else if (this.state.lang === "") {
      this.setState({
        langError: "Please select language",
        isLoading: false,
      });
    } else {
      let login = {
        email: this.state.email,
        password: this.state.password,
      };

      await this.props.userLogin(login);

      setTimeout(() => {
        if (this.props.successMessage === false) {
          this.setState({
            isLoading: false,
          });
        } else {
          this.setState({
            isLoading: false,
          });
        }
      }, 1000);
    }
  };

  loginOnKeyPress = async (e) => {
    if (e.which === 13 || e.keyCode === 13) {
      this.setState({
        isLoading: true,
        responseStatus2: false,
      });
      let emailvalue = this.state.email;
      // eslint-disable-next-line no-useless-escape
      let emailrex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!emailvalue) {
        this.setState({
          emailError: "Email cant be blank",
          emailvalidError: true,
          isLoading: false,
        });
        return false;
      } else if (!emailrex.test(String(emailvalue))) {
        this.setState({
          emailError: "Email is not valid",
          emailvalidError: true,
          isLoading: false,
        });
        return false;
      } else if (this.state.password === "") {
        this.setState({
          passwordValidError: true,
          passworderror: `Password can't be blank`,
          isLoading: false,
        });
      } else if (this.state.lang === "") {
        this.setState({
          langError: "Please select app language",
          isLoading: false,
        });
      } else {
        let login = {
          email: this.state.email,
          password: this.state.password,
        };

        await this.props.userLogin(login);
        setTimeout(() => {
          if (this.props.successMessage === false) {
            this.setState({
              isLoading: false,
            });
          } else {
            this.setState({
              isLoading: false,
            });
          }
        }, 1000);
      }
    }
  };

  forgetPassword = () => {
    this.setState({
      isResetPassword: true,
      emailError: "",
      emailvalidError: false,
    });
  };

  handleChange = (otp) => this.setState({ otp });

  newPassword(e) {
    this.setState({
      newPassword: e.target.value,
    });
  }
  confirmNewPassword(e) {
    this.setState({
      confirmNewPassword: e.target.value,
    });
  }

  acceptInvitation = async () => {
    if (this.state.newPassword === "") {
      this.setState({
        successEnable: true,
        successMessageText: "Please enter new password",
      });
    } else if (this.state.confirmNewPassword === "") {
      this.setState({
        successEnable: true,
        successMessageText: "Please enter confirm password",
      });
    } else if (this.state.newPassword !== this.state.confirmNewPassword) {
      this.setState({
        successEnable: true,
        successMessageText: "Password did not match",
      });
    } else {
      this.setState({
        isOtpResetLoading: true,
      });
      let obj = {
        otp: this.state.otp,
        password: this.state.newPassword,
      };
      await this.props.acceptInvite(obj);
      await this.setState({
        isOtpResetLoading: false,
      });
    }
  };

  onKeyPressChangePassword = async (e) => {
    // eslint-disable-next-line no-restricted-globals
    if (e.which === 13 || event.keyCode === 13) {
      if (this.state.newPassword === "") {
        this.setState({
          successEnable: true,
          successMessageText: "Please enter new password",
        });
      } else if (this.state.confirmNewPassword === "") {
        this.setState({
          successEnable: true,
          successMessageText: "Please enter confirm password",
        });
      } else if (this.state.newPassword !== this.state.confirmNewPassword) {
        this.setState({
          successEnable: true,
          successMessageText: "Password did not match",
        });
      }
      // else if (this.state.otp.length < 6) {
      //     this.setState({
      //         successEnable: true,
      //         successMessageText: "Please enter all the code fields",
      //     })
      // }
      else {
        this.setState({
          isOtpResetLoading: true,
        });
        let obj = {
          otp: this.state.otp,
          password: this.state.newPassword,
        };
        await this.props.acceptInvite(obj);
        await this.setState({
          isOtpResetLoading: false,
        });
      }
    }
  };

  handleOtpEmail = async () => {
    // eslint-disable-next-line no-useless-escape
    let emailrex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (!this.state.otpEmail) {
      this.setState({
        emailError: "Email cant be blank",
        emailvalidError: true,
      });
      return false;
    } else if (!emailrex.test(String(this.state.otpEmail))) {
      this.setState({
        // emailvalidError: 'Email is not valid',
        emailError: "Email is not valid",
        emailvalidError: true,
      });
      return false;
    } else {
      this.setState({
        isOtpEmailLoading: true,
      });
      await this.props.forgotPassword(this.state.otpEmail);
      this.setState({
        isOtpEmailLoading: false,
        otpEnable: true,
        emailOtpScreen: false,
      });
    }
  };
  snackClosed = () => {
    this.props.clearErrors();
    this.setState({
      successMessage: false,
      successEnable: false,
      successMessageText: "",
    });
  };

  onOtpEmailChange = (e) => {
    this.setState({
      emailError: "",
      emailvalidError: false,
      otpEmail: e.target.value,
    });
  };

  onOtpEmailChangeKeyPress = (e) => {
    // eslint-disable-next-line no-restricted-globals
    if (e.which === 13 || event.keyCode === 13) {
      // eslint-disable-next-line no-useless-escape
      let emailrex =
        /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!this.state.otpEmail) {
        this.setState({
          emailError: "Email cant be blank",
          emailvalidError: true,
        });
        return false;
      } else if (!emailrex.test(String(this.state.otpEmail))) {
        this.setState({
          // emailvalidError: 'Email is not valid',
          emailError: "Email is not valid",
          emailvalidError: true,
        });
        return false;
      } else {
        this.setState({
          isOtpEmailLoading: true,
        });
      }
    }
  };

  resetPassword = async () => {
    if (this.state.newPassword === "") {
      this.setState({
        successEnable: true,
        successMessageText: "Please enter new password",
      });
    } else if (this.state.confirmNewPassword === "") {
      this.setState({
        successEnable: true,
        successMessageText: "Please enter confirm password",
      });
    } else if (this.state.newPassword !== this.state.confirmNewPassword) {
      this.setState({
        successEnable: true,
        successMessageText: "Password did not match",
      });
    } else if (this.state.otp.length < 6) {
      this.setState({
        successEnable: true,
        successMessageText: "Please enter all the code fields",
      });
    } else {
      this.setState({
        isOtpResetLoading: true,
      });
      let obj = {
        otp: this.state.otp,
        password: this.state.newPassword,
      };
      await this.props.resetPasswords(obj);
      this.setState({
        resetPasswordComplete: true,
        isOtpResetLoading: false,
      });
    }
  };



  redirectTologin() {
    window.location.reload();
  }

  changeLang = (e) => {
    this.setState(
      {
        lang: e,
        langError: "",
      },
      () => {
        i18n.changeLanguage(e);
        if (this.state.lang === "hi") {
          localStorage.setItem("lang", "hi");
        } else if (this.state.lang === "en") {
          localStorage.setItem("lang", "en");
        } else if (this.state.lang === "es") {
          localStorage.setItem("lang", "es");
        }
      }
    );
  };
  render() {
    const theme = JSON.parse(localStorage.getItem('theme'));
    const { successMessage, successMessageText, successEnable } = this.props;
    const defaultOptions = {
      loop: true,
      autoplay: true,
      animationData: Loading,
      rendererSettings: {
        preserveAspectRatio: "xMidYMid slice",
      },
    };
    return (
      <Fragment>
        <Helmet>
          <title>{`${this.state.company} - Elite Learning`}</title>
          <link rel="canonical" href={window.location.origin} />
        </Helmet>
        {this.state.showLoading ?
          <div style={{ position: 'absolute', top: '45%', left: '50%', transform: 'translate(-50%,-50%)' }}>
            <Lottie options={defaultOptions} width='400px' height='400px' />
            <p className="text-center">Loading please wait...</p>
          </div>
          :
          !this.state.nofound ? (
            <div
              className="login-module"
              style={{ background: `url(${this.state.imgSelected?.image}) no-repeat center center fixed` }}
            >
              <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                open={this.state.successEnable}
                onClose={() => this.snackClosed()}
                message={this.state.successMessageText}
                autoHideDuration={4000}
              />
              <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                open={successMessage}
                onClose={() => this.snackClosed()}
                message={successMessageText}
                autoHideDuration={4000}
              />
              <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                open={successEnable}
                onClose={() => this.snackClosed()}
                message={successMessageText}
                autoHideDuration={4000}
              />

              <div className="login-holder">
                {
                  this.state.defaultShow ? (
                    <div className="login-box text-center">

                      {!this.state.isResetPassword ? (
                        <Fragment>
                          <div title={localStorage.getItem('company')} style={{ backgroundImage: `url(${this.state.logo})`, backgroundPosition: 'center center', backgroundSize: 'contain', backgroundRepeat: 'no-repeat', width: '100%', height: 65 }}>

                          </div>
                          {/* <img src={this.state.logo} alt="" height="52px" /> */}
                          <p className="text-center">Login to start learning </p>
                          <div className="form-group mt-4">

                            <div className="has-search">
                              <span className="form-control-feedback">
                                <img src="/images/email-icon.svg" alt="" />
                              </span>
                              <input
                                type="email"
                                className="form-control"
                                id="exampleInputEmail1"
                                aria-describedby="emailHelp"
                                placeholder="Email"
                                value={this.state.email}
                                onChange={(e) => this.onEmailChange(e)}
                                onKeyPress={(e) => this.loginOnKeyPress(e)}
                              />
                            </div>
                            {this.state.emailvalidError ? (
                              <small>{this.state.emailError}</small>
                            ) : null}
                          </div>
                          <div className="form-group" style={{ marginTop: -7 }}>

                            <div className="has-search">
                              <span
                                className="form-control-feedback"
                                style={{ marginTop: 12 }}
                              >
                                <img src="/images/lock-icon.svg" alt="" />
                              </span>
                              <input
                                type="password"
                                className="form-control"
                                aria-describedby="emailHelp"
                                placeholder="Password"
                                onChange={(e) => this.onChangePassword(e)}
                                onKeyPress={(e) => this.loginOnKeyPress(e)}
                              />
                            </div>
                            {this.state.passwordValidError ? (
                              <small>{this.state.passworderror}</small>
                            ) : null}
                          </div>
                          <div
                            className="form-group text-left"
                            style={{ marginTop: -7 }}
                          >
                            <label>App Language</label>
                            {this.state.langError ? (
                              <small className="mt-1">{this.state.langError}</small>
                            ) : null}
                            <div className="elite-lang-select">
                              <div
                                style={{
                                  border:
                                    this.state.lang === "en"
                                      ? "2px solid #5FBB97"
                                      : "2px solid #fff",
                                }}
                                onClick={() => this.changeLang("en")}
                              >
                                English
                              </div>
                              <div
                                style={{
                                  border:
                                    this.state.lang === "hi"
                                      ? "2px solid #5FBB97"
                                      : "2px solid #fff",
                                }}
                                onClick={() => this.changeLang("hi")}
                              >
                                हिन्दी
                              </div>
                              <div
                                style={{
                                  border:
                                    this.state.lang === "es"
                                      ? "2px solid #5FBB97"
                                      : "2px solid #fff",
                                }}
                                onClick={() => this.changeLang("es")}
                              >
                                español
                              </div>
                            </div>
                          </div>
                          <div className="form-group" style={{ marginTop: -3 }}>
                            {<button
                              className="form-control button-color position-relative"
                              style={{ borderRadius: 2, fontWeight: "bold", backgroundColor: theme?.bgColor }}
                              onClick={() => this.loginUser()}
                            >
                              {this.state.isLoading ? (
                                <BallBeat color={"#fff"} loading={true} />
                              ) : (
                                "Login"
                              )}
                            </button>}
                          </div>

                          <h3
                            className="mt-2 cursor-pointer"
                            style={{ color: theme?.bgColor }}
                            onClick={() => this.forgetPassword()}
                          >
                            Forgot Password?
                          </h3>
                          {window.location.origin === 'https://edsanta.elitelearning.io' ?
                            <Fragment>
                              <p>OR</p>
                              <div className="mt-2">

                                <GLogin />
                              </div>
                            </Fragment> :
                            null
                          }

                          {!JSON.parse(localStorage.getItem('whitelabelled')) ? null :
                            <h3 className="mt-2" style={{ color: '#000000' }}>
                              New user? <Link style={{ color: theme?.bgColor }} to='/signup'>Sign up here</Link>
                            </h3>}

                          {
                            !JSON.parse(localStorage.getItem('whitelabelled')) ?
                              <h4 style={{ paddingTop: 10 }}>
                                Powered by <br />
                                <img src="/images/elite-logo.svg" alt="" />
                              </h4> : null
                          }
                          {this.state.apple_store && this.state.play_store &&
                            <Fragment>
                              <p className="mt-2">{!JSON.parse(localStorage.getItem('whitelabelled')) ? 'Download the Elite mobile app' : 'Download the mobile app'}</p>
                              <div className="d-flex justify-content-between align-items-center mt-2">
                                <a
                                  href={this.state.play_store}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <img
                                    alt=""
                                    src="/images/app-link.jpg"
                                    width="120px"
                                  />
                                </a>
                                <a
                                  href={this.state.apple_store}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  <img
                                    alt=""
                                    src="/images/ios-link1.png"
                                    width="120px"
                                  />
                                </a>
                              </div>
                            </Fragment>
                          }
                        </Fragment>
                      ) : (
                        <div className="otp-holder">
                          <h3 style={{ color: theme?.bgColor }}>Reset your password.</h3>
                          {this.state.otpEnable === false &&
                            this.state.emailOtpScreen ? (
                            <Fragment>
                              <p>Please enter your registered Email address.</p>
                              <div className="form-group mt-3 w-100">
                                {this.state.responseStatus ? (
                                  <small>{this.state.resposneStatusText}</small>
                                ) : null}

                                <input
                                  type="email"
                                  className="form-control"
                                  aria-describedby="emailHelp"
                                  placeholder="Email"
                                  onChange={(e) => this.onOtpEmailChange(e)}
                                  onKeyPress={(e) =>
                                    this.onOtpEmailChangeKeyPress(e)
                                  }
                                  value={this.state.otpEmail}
                                />
                                {this.state.emailvalidError ? (
                                  <small>{this.state.emailError}</small>
                                ) : null}
                              </div>
                              <button
                                onClick={() => this.handleOtpEmail()}
                                style={{ backgroundColor: theme?.bgColor }}
                                className="primary-button position-relative mb-1"
                              >
                                {this.state.isOtpEmailLoading ? (
                                  <BallBeat color={"#fff"} loading={true} />
                                ) : (
                                  "CONTINUE"
                                )}
                              </button>
                            </Fragment>
                          ) : this.state.resetPasswordComplete === false ? (
                            <div className="otp-fields d-flex flex-column align-items-center">
                              <p>
                                Please enter the code that is sent to your mail.
                              </p>
                              {/* <OtpInput
                                                            numInputs={6}
                                                            onChange={this.handleChange}
                                                            inputStyle="otp-input"
                                                            value={this.state.otp}
                                                            separator={<span>-</span>}
                                                        /> */}
                              <div className="form-group" style={{ width: "97%" }}>
                                <input
                                  type="text"
                                  autoComplete="off"
                                  className="form-control"
                                  onChange={(e) =>
                                    this.handleChange(e.target.value)
                                  }
                                  style={{ height: 48 }}
                                  value={this.state.otp}
                                  placeholder="Enter otp"
                                />
                                <input
                                  type="password"
                                  placeholder="Enter new password"
                                  className="form-control mt-2"
                                  aria-describedby="emailHelp"
                                  onChange={(e) => this.newPassword(e)}
                                  onKeyPress={(e) =>
                                    this.onKeyPressChangePassword(e)
                                  }
                                />
                                <input
                                  type="password"
                                  placeholder="Confirm new password"
                                  className="form-control mt-2"
                                  aria-describedby="emailHelp"
                                  onChange={(e) => this.confirmNewPassword(e)}
                                  onKeyPress={(e) =>
                                    this.onKeyPressChangePassword(e)
                                  }
                                />
                              </div>

                              <button
                                disabled={
                                  this.state.isOtpResetLoading !== false
                                }
                                style={{ backgroundColor: theme?.bgColor }}
                                onClick={() => this.resetPassword()}
                                className="primary-button position-relative"
                              >
                                {this.state.isOtpResetLoading ? (
                                  <BallBeat color={"#fff"} loading={true} />
                                ) : (
                                  "Reset"
                                )}
                              </button>
                            </div>
                          ) : (
                            <div className="success-pasword-reset">
                              <p>Password has been successfully changed</p>
                              <button
                                onClick={() => this.redirectTologin()}
                                className="primary-button mt-2"
                              >
                                Login
                              </button>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  ) : (
                    <div className="otp-holder">
                      <h3>Set your password.</h3>
                      {
                        <div className="otp-fields">
                          <p>Please enter the code that is sent to your mail.</p>
                          {/* <OtpInput
                                        numInputs={6}
                                        onChange={this.handleChange}
                                        inputStyle="otp-input"
                                        value={this.state.otp}
                                        separator={<span>-</span>}
                                    /> */}

                          <div className="form-group mt-2">
                            <input
                              className="form-control"
                              type="text"
                              autoComplete="off"
                              onChange={(e) => this.handleChange(e.target.value)}
                              style={{ height: 48 }}
                              value={this.state.otp}
                              placeholder="Enter otp"
                            />
                            <input
                              type="password"
                              placeholder="Enter new password"
                              className="form-control mt-2"
                              aria-describedby="emailHelp"
                              onChange={(e) => this.newPassword(e)}
                              onKeyPress={(e) => this.onKeyPressChangePassword(e)}
                            />
                            <input
                              type="password"
                              placeholder="Confirm new password"
                              className="form-control mt-2"
                              aria-describedby="emailHelp"
                              onChange={(e) => this.confirmNewPassword(e)}
                              onKeyPress={(e) => this.onKeyPressChangePassword(e)}
                            />
                          </div>

                          <button
                            disabled={
                              this.state.isOtpResetLoading !== false
                            }
                            style={{ backgroundColor: theme?.bgColor }}
                            onClick={() => this.acceptInvitation()}
                            className="primary-button position-relative"
                          >
                            {this.state.isOtpResetLoading ? (
                              <BallBeat color={"#fff"} loading={true} />
                            ) : (
                              "Set"
                            )}
                          </button>
                        </div>
                      }
                    </div>
                  )
                }
              </div>
            </div>
          ) :
            <Nofound />
        }
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  const { isAuthorized } = state.login;
  const { successMessage, successMessageText, successEnable } = state.error;
  return { successMessage, successMessageText, successEnable, isAuthorized };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ userLogin, acceptInvite, forgotPassword, resetPasswords, autoLogin, clearErrors }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Login));
